import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Radio } from 'react-bootstrap';

import SingleLocationDropdown from 'components/SingleLocationDropdown/SingleLocationDropdown';

import styles from './PostRemote.module.scss';

const PostRemote = ({
  onChangeRemote,
  locationSelected,
  remoteSelected,
  onChangeLocation,
}) => (
  <form className={styles.form} id="post-brief-remote">
    <p className="fs-15 lato-bold">Is the freelancer required onsite?</p>
    <FormGroup>
      <div style={{ border: '1px solid #ddd', borderRadius: '4px' }}>
        <div className="fs-15" style={{ borderTop: 0, padding: '10px' }}>
          <Radio
            className={styles.radio}
            id="post-brief-work-remotely"
            onChange={() => onChangeRemote(true)}
            checked={remoteSelected}
          >
            No, we can work online
          </Radio>
        </div>
        <div
          className="fs-15"
          style={{ borderTop: '1px solid #ddd', padding: '10px' }}
        >
          <Radio
            className={styles.radio}
            id="post-brief-work-local"
            onChange={() => onChangeRemote(false)}
            checked={!remoteSelected}
          >
            Yes, they need to be at a location
          </Radio>
        </div>
      </div>
      {!remoteSelected && (
        <div>
          <hr />
          <p className="mt fs-15 mb lato-bold">
            Where do they need to be based?
          </p>
          <SingleLocationDropdown
            placeholder="Enter a city or country"
            shouldClearOnBlur={!locationSelected}
            onLocationChange={(location) => onChangeLocation(location)}
            shouldResetOnBlur={true}
            onLocationReset={() => onChangeLocation(null)}
            showResetIcon={true}
          />
        </div>
      )}
    </FormGroup>
  </form>
);

PostRemote.propTypes = {
  onChangeRemote: PropTypes.func,
  locationSelected: PropTypes.bool,
  remoteSelected: PropTypes.bool,
  onChangeLocation: PropTypes.func,
};

export default PostRemote;
